import PlanSalesService from "@/api/services/planSales";
import { toCamelCase } from "@estaly/ui";

const normalizeStatus = (planSale) => String(planSale?.status ?? "").toLowerCase();

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    setIndex(state, data) {
      state.index = data.records || [];
      state.currentPage = data.page?.currentPage || 1;
      state.totalPages = data.page?.totalPages || 0;
      state.totalCount = data.page?.totalCount || 0;
    },
  },

  getters: {
    statuses: () => () => ["active", "expired", "cancelled", "suspended"],

    isActive: () => (planSale) => normalizeStatus(planSale) === "active",

    isCancelled: () => (planSale) => normalizeStatus(planSale) === "cancelled",

    isUpdatable: () => (planSale) => ["active", "suspended"].includes(normalizeStatus(planSale)),

    statusBadgeClass: () => (planSale) => {
      switch (normalizeStatus(planSale)) {
        case "active":
          return "bg-green-200 text-green-800";
        case "expired":
        case "suspended":
          return "bg-gray-200 text-gray-600";
        case "cancelled":
          return "bg-red-200 text-red-800";
        default:
          return "bg-gray-100 text-gray-500";
      }
    },

    statusListStyle: () => (planSale) => {
      switch (normalizeStatus(planSale)) {
        case "active":
          return "text-green-500 bg-green-100 border border-green-300";
        case "cancelled":
          return "text-red-500 bg-red-100 border border-red-300";
        case "expired":
          return "text-gray-500 bg-gray-100 border border-gray-300";
        case "suspended":
          return "text-yellow-500 bg-yellow-100 border border-yellow-300";
        default:
          return "text-gray-500 bg-gray-100 border border-gray-300";
      }
    },
  },

  actions: {
    async fetchIndex(
      { commit },
      { storeIds = [], status = [], keywords = null, startDate = null, endDate = null, page, includes = [] } = {},
    ) {
      const response = await PlanSalesService.fetchIndex({
        storeIds,
        status,
        keywords,
        startDate,
        endDate,
        page,
        includes,
      });
      if (!response?.success) return null;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return data;
    },

    async fetch(_, { id, includes = [] }) {
      const response = await PlanSalesService.fetch(id, includes);
      if (!response?.success) return null;

      return toCamelCase(response.data);
    },

    async update(_, { id, planSale }) {
      return await PlanSalesService.update(id, { planSale });
    },

    async cancel(_, { id, cancellation }) {
      return await PlanSalesService.cancel(id, cancellation);
    },

    async sendConfirmationEmail(_, { id }) {
      return await PlanSalesService.sendConfirmationEmail(id);
    },
  },
};
